export interface ClientFrameType {
  nin?: string
  name?: string
  phone?: string
  email?: string
  address?: string
  dateBirth?: string
  compraPara?: {
    enabled: boolean
    ownerName: string
    ownerRut: string
  }
}
import { useFeatureFlag } from '../hooks/useFeatureFlag'
import { fechaIsoToDD_MM_YYYY } from '../utils/utils'

import { ClientFrame as ClientFrameV2 } from './ClientFrameV2'

export const ClientFrame: React.FC<{ client: ClientFrameType }> = ({ client }) => {
  const { useNewDocumentUI } = useFeatureFlag()

  if (useNewDocumentUI) return <ClientFrameV2 client={client} />

  return (
    <>
      <div className="mb-2">
        <span className="text-[1.5em]">Datos del Cliente</span>
      </div>

      <div className="grid grid-cols-6 gap-x-2 gap-y-0">
        <div className="">Nombre</div>
        <div className="col-span-2 font-bold">{client.name}</div>

        <div className="">Rut</div>
        <div className="col-span-2 font-bold">{client.nin}</div>

        <div className="">Teléfono</div>
        <div className="col-span-2 font-bold">{client.phone}</div>

        <div className="">Email</div>
        <div className="col-span-2 font-bold">{client.email}</div>

        <div className="">Dirección</div>
        <div className="col-span-5 font-bold">{client.address}</div>
        {client.dateBirth && (
          <>
            <div className="">Fecha de nacimiento</div>
            <div className="col-span-3 font-bold">{fechaIsoToDD_MM_YYYY(client.dateBirth)}</div>
          </>
        )}
      </div>

      {client.compraPara?.enabled && (
        <>
          <div className="mb-2 mt-4">
            <span className="text-[1.5em] uppercase">Compra Para</span>
          </div>

          <div className="grid grid-cols-6 gap-x-2 gap-y-0">
            <div className="">Nombre</div>
            <div className="col-span-2 font-bold">{client.compraPara.ownerName}</div>

            <div className="">Rut</div>
            <div className="col-span-2 font-bold">{client.compraPara.ownerRut}</div>
          </div>
        </>
      )}
    </>
  )
}
